<script setup lang="ts">
import AndroidUpdatesView from '@/components/admin/views/AndroidUpdatesView.vue'
</script>

<template>
  <AndroidUpdatesView />
</template>
